import React, { useEffect } from 'react'
import MapWithAMarker from './google-maps';
import './styles.css';
import { useIsMobile } from '../../../hooks/breakpoints'
import { useAppState } from '../../../contexts/appState'
import useTranslation from '../../../hooks/use-translation'
import { raiseGAEventForVaccination, sendPageViewEvent } from '../../../utils/network'
import config from '../../../config.json'

const CenterDetails = ({ handleNext, data }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const [{ booking }] = useAppState();

  // useEffect(() => {
  //   if (window.location.pathname === '/book-appointment/corporate') {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/corporate/center-details' })
  //   } else {
  //     sendPageViewEvent({ VirtualPageTitle: 'book-appointment/all-centers/center-details' })
  //   }
  // }, [])

  const handleNextPage = () => {
    // raiseGAEventForVaccination({ new_Category: config.gaBookAppointment, new_Action: config.gaLocationDetailsProceed, new_Label: data?.name })
    handleNext()
  }

  return (
    <div className={isMobile ? '' : 'parent-container'}>

      <Address name={data?.name} address={data?.address} isMobile={isMobile} t={t} />
      <BreakLine />

      <Location distance={data?.distance} lat={data?.lat} lng={data?.lng} booking={booking} t={t} />
      <BreakLine />

      {/* Awaiting update 
      <VaccineAndDose />
      <BreakLine /> */}

      <AgeGroup ageLimit={data?.vaccination_min_age_limit} ageColor={data?.color_age_rule} isMobile={isMobile} t={t} />
      <BreakLine />

      <CallForDetails phone_number={data?.phone_number} email_id={data?.email_id} isMobile={isMobile} t={t} />

      <button className="btn" style={{ marginRight: `${isMobile ? '10px' : ''}`, width: `${isMobile ? '100%' : ''}`, marginBottom: '2rem' }} onClick={() => handleNextPage()} >Next</button>
    </div >
  )
}

const Address = ({ name, address, isMobile, t }) => (
  <div className={isMobile ? 'flex-col-mobile' : "flex-col"}>
    {!isMobile && <span className="label">{t('ADDRESS')}</span>}
    <span className={isMobile ? "title-mobile" : "title"}>{name}</span>
    <p className="full-address">{address}</p>
  </div >
)

const Location = ({ distance, lat, lng, booking, t }) => {
  const redirectToGoogleMaps = (lat, lng) => {
    const url = "http://maps.google.com/maps?daddr=" + lat + "," + lng;
    const win = window.open(url, "_blank");
    win.focus();
  }
  return (
    <div className="flex-col">
      <div className="grid-row-location">
        <span className="label" style={{ marginLeft: '1rem' }}>{t('LOCATION')}</span>
        <div className="distance">
          <img width='20px' height='20px' src='/icons/distance.svg' />
          <span>{`${distance} KM`}</span>
        </div>
        <div className="direction" onClick={() => redirectToGoogleMaps(lat, lng)}>
          <img width='20px' height='20px' src='/icons/direction.svg' />
          <span>Get Direction</span>
        </div>
      </div>

      <MapWithAMarker
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCxAUn1UUc-bipWV7-Z4NVVWovdIC_B48A"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `180px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        lat={parseFloat(lat)}
        lng={parseFloat(lng)}
      />
    </div >
  )
}

const VaccineAndDose = () => (
  <div className="flex-col">
    <span className="label">Vaccine name and dose details</span>
    <ul>
      <li>1. Covaxin <span>(Dose 1 & 2 available)</span></li>
      <li>2. Covishield <span>(Dose 1 available)</span></li>
    </ul>
  </div>
)

const AgeGroup = ({ ageLimit, ageColor, isMobile, t }) => (
  <div className={isMobile ? 'mobile-view' : "flex-row"}>
    <span className="label">{t('AGE_GROUP_LABEL')}</span>
    <span className="badge" style={{ background: ageColor }}> {ageLimit}</span>
  </div >
)
const CallForDetails = ({ phone_number, email_id, isMobile, t }) => (
  <div className={isMobile ? 'mobile-view' : "flex-row"}>
    <span className="label">{t('CENTER_DETAILS_CALL_LABEL')}</span>
    <span className="badge">
      <img width='15px' height='15px' src='/icons/call.svg' />
      <a href={`tel:${phone_number}`}>
        {phone_number}
      </a>
    </span>
  </div>
)
const BreakLine = () => (
  <div className="break-line"></div>
)


export default CenterDetails;
